import React, { useEffect, useState, useRef } from 'react';
import Box from "@material-ui/core/Box";
import TipoRecoleccionLista from "./TipoRecoleccionLista";
import RecoleccionFecha from "./RecoleccionFecha";
import { IRecoleccion } from "../../redux/types/recoleccionActionTypes";
import { connect } from "react-redux"
import { FormControl, Grid, MenuItem, Select } from "@material-ui/core";
import AutocompleteControl, { IAutocomplete } from "../controls/AutocompleteControl";
import { enums } from "../../enums/enums";
import { ApplicationState } from "../../redux/reducers";
import SucursalComponente from "./Sucursal";
import NextButton from "../controls/NextButton";
import { initialRecoleccionState } from "../../redux/reducers/recoleccionReducer";
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import ServicioAdicionalLista from "../servicioAdicional/servicioAdicionalLista";
import { ServicioAdicional } from "../../entities/catalogos/ServicioAdicional";
import { Colonia } from "../../entities/catalogos/Colonia";
import { AreaServicio } from "../../entities/catalogos/AreaServicio";
import { Sucursal } from "../../entities/catalogos/Sucursal";
import { ICliente } from "../../entities/catalogos/ICliente";
import useCommonApi from "../../api/useCommonApi";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import swal from 'sweetalert2';
import Help, { IHelp } from '../help/Help';
import { useSnackbar } from "notistack";
import { obtenerServiciosAdicionales } from "../../blocks/utility";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import { ICatalogo } from '../../entities/catalogos/ICatalogo';
import { trimEnd } from 'lodash';

interface OwnProps {
    esOrigen: boolean
    value: IRecoleccion
    siguientePaso: (recoleccion: IRecoleccion, esOrigen: boolean) => void
    cotizacionId: number
}

interface StateProps {
    cliente: ICliente,
    solicitud: Solicitud
    solicitudCopia: Solicitud
    ayuda: IHelp,
    recoleccion?: any,
    idiomaId: string,
    paises: ICatalogo[]
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud,
    setSolicitudCopia: typeof setSolicitudCopia
}

type Props = OwnProps & StateProps & DispatchProps


const Recoleccion = ({paises, ...props }: Props) => {

    const { enqueueSnackbar } = useSnackbar();
    const codigoPostalInicial = props.value?.codigoPostal !== "" ? {
        id: props.value?.colonia?.id ? props.value?.colonia?.id : 0,
        nombre: props.value.codigoPostal.toString(),
        descripcion: "",
        parentId: Number(props.value.codigoPostal)
    } : null;

    const [recoleccion, setRecoleccion] = useState<IRecoleccion>(props.value);
    const [codigoPostal, setCodigoPostal] = useState<IAutocomplete | null>(codigoPostalInicial);
    const apiSource = useCommonApi();
    const [cpFueraArea, setCPFueraArea] = useState(false);
    
    React.useEffect(() => {
        var clienteNuevaConfig = localStorage.getItem("clienteString")?.toString() !==null ? (localStorage.getItem("clienteString")?.toString() !==undefined ? localStorage.getItem("clienteString") : "") :"" ;
        var clienteObject =  clienteNuevaConfig !== null ? (clienteNuevaConfig !== "" ? JSON.parse(clienteNuevaConfig) : "") : "";
        if(clienteObject !== ""){
            localStorage.setItem("clienteString", "");
            if(props.esOrigen){
                handleCodigoPostalRender(null, props.value.colonia).then();
            }
            //setLoading(true);
        }
        
    }, [localStorage.getItem("clienteString")]);

    const updateSolicitudCopiaFH = (propiedad: string, value: any, propiedad2: string, value2: any,
        propiedad3: string, value3: any, sucursal?: Sucursal) => {
        const copiaSolicitud = new Solicitud(props.solicitudCopia);

        copiaSolicitud.SetPropiedadRecoleccionFH(propiedad, value, propiedad2, value2, propiedad3, value3, props.esOrigen, false);

        if (sucursal) {
            copiaSolicitud.SetPropiedadRecoleccion("sucursal", sucursal, props.esOrigen);
        }

        setSolicitudCopia(copiaSolicitud);
        setSolicitud(copiaSolicitud);
    };

    const updateRecoleccion = (valorPropiedad: any, nombrePropiedad: string) => {
        if (valorPropiedad) {
            let nuevaRecoleccion = { ...recoleccion, [nombrePropiedad]: valorPropiedad, completado: true };

            if (nombrePropiedad === 'fechaCita') {
                delete nuevaRecoleccion['fechaRecoleccion'];
                delete nuevaRecoleccion['EsFueraHorario'];
                delete nuevaRecoleccion['horaFHDe'];
                delete nuevaRecoleccion['horaFHHasta'];
                delete nuevaRecoleccion['fechaCitaCedis'];
            }
            if (nombrePropiedad === 'fechaRecoleccion') {
                delete nuevaRecoleccion['fechaCita'];
                delete nuevaRecoleccion['EsFueraHorario'];
                delete nuevaRecoleccion['horaFHDe'];
                delete nuevaRecoleccion['horaFHHasta'];
                delete nuevaRecoleccion['fechaCitaCedis'];
            }
            if (nombrePropiedad === 'fechaCitaCedis') {
                delete nuevaRecoleccion['fechaCita'];
                delete nuevaRecoleccion['fechaRecoleccion'];
                delete nuevaRecoleccion['EsFueraHorario'];
                delete nuevaRecoleccion['horaFHDe'];
                delete nuevaRecoleccion['horaFHHasta'];
            }
            setRecoleccion(nuevaRecoleccion);
        }
    }

    const updateRecoleccionNull = (valorPropiedad: any, nombrePropiedad: string) => {
        let nuevaRecoleccion = { ...recoleccion, [nombrePropiedad]: valorPropiedad, completado: true };

        if (nombrePropiedad === 'fechaCita') {
            delete nuevaRecoleccion['fechaRecoleccion'];
            delete nuevaRecoleccion['EsFueraHorario'];
            delete nuevaRecoleccion['horaFHDe'];
            delete nuevaRecoleccion['horaFHHasta'];
            delete nuevaRecoleccion['fechaCitaCedis'];
        }

        if (nombrePropiedad === 'fechaCitaCedis') {
            delete nuevaRecoleccion['fechaRecoleccion'];
            delete nuevaRecoleccion['EsFueraHorario'];
            delete nuevaRecoleccion['horaFHDe'];
            delete nuevaRecoleccion['horaFHHasta'];
            delete nuevaRecoleccion['fechaCita'];
        }

        setRecoleccion(nuevaRecoleccion);
    }

    const updateRecoleccionFueraHorario = (valorPropiedadFecha: any, nombrePropiedadFecha: string,
        valorPropiedadHoraDe: any, nombrePropiedadHoraDe: string, valorPropiedadHoraHasta: any, nombrePropiedadHoraHasta: string) => {

        let nuevaRecoleccion = { ...recoleccion, [nombrePropiedadFecha]: valorPropiedadFecha, [nombrePropiedadHoraDe]: valorPropiedadHoraDe, [nombrePropiedadHoraHasta]: valorPropiedadHoraHasta, ["EsFueraHorario"]: true, completado: true };
        if (nombrePropiedadFecha === 'fechaCita') {
            delete nuevaRecoleccion['fechaRecoleccion'];
        }

        setRecoleccion(nuevaRecoleccion);

        updateSolicitudCopiaFH(nombrePropiedadFecha, valorPropiedadFecha, nombrePropiedadHoraDe, valorPropiedadHoraDe, nombrePropiedadHoraHasta, valorPropiedadHoraHasta);
    }

    const setDatosRecoleccionRender = (areaServicio: AreaServicio, copiaRecoleccion: IRecoleccion, sucursal?: Sucursal) => {
        let esServicioInternacional = copiaRecoleccion.paisId === enums.pais.usa;

        if (areaServicio.id > 0) {
            const esRadConCita = props.cliente.esRadConCita && areaServicio.esRadConCita;
            const esEadConCita = props.cliente.esEadConCita && areaServicio.esEadConCita;
            let serviciosAdicionales = obtenerServiciosAdicionales(areaServicio.serviciosAdicionales, true, props.esOrigen);
            let serviciosOrigenDestino = serviciosAdicionales.filter(s => s.esSeccionOrigenDestino);
            let tieneCruceFronterizo = serviciosOrigenDestino.some(e => e.nombre.includes("FLETE CRUCE FRONTERIZO"));
            let esPuertoAeropuerto = false;
            let esComercioExterior = esPuertoAeropuerto || esServicioInternacional;
            let intraUSA = esServicioInternacional ? {esSeleccionable: true, seleccionado: false} : undefined;
            const serviciosSeccionSevcios = serviciosAdicionales.filter(s => s.esSeccionServiciosAdicionales);
            const copiaAreaServicio = new AreaServicio({ ...areaServicio, serviciosAdicionales: serviciosSeccionSevcios });
            copiaAreaServicio.ObtenerGrupoHorarios();

            var tipoRecoleccionId = 1;
            if (props.esOrigen) {
                serviciosOrigenDestino = esRadConCita ? serviciosOrigenDestino : serviciosOrigenDestino.filter(c => c.nombre !== 'CARGO POR CITA RAD');
                tipoRecoleccionId = props.value.tipoRecoleccionId === undefined || esServicioInternacional ? 1 : props.value.tipoRecoleccionId;
            }
            else {
                serviciosOrigenDestino = esEadConCita ? serviciosOrigenDestino : serviciosOrigenDestino.filter(c => c.nombre !== 'CARGO POR CITA EAD')
                tipoRecoleccionId = props.value.tipoRecoleccionId === undefined || esServicioInternacional ? 1 : props.value.tipoRecoleccionId;
            }
            setRecoleccion({
                ...copiaRecoleccion,
                tieneCruceFronterizo,
                areaServicio: copiaAreaServicio,
                sucursal: sucursal || new Sucursal(areaServicio.sucursal),
                aceptaCita: ((props.esOrigen && esRadConCita) || (!props.esOrigen && esEadConCita) || localStorage["tipo_usuario"].toLowerCase() === "invitado"),
                esForanea: areaServicio.esForanea,
                serviciosAdicionales: serviciosOrigenDestino, 
                tipoRecoleccionId, 
                completado: true,
                esComercioExterior: esComercioExterior,
                esServicioInternacional: esServicioInternacional,
                eliminaRetornoDocumentos:  false
            });
        } else {
            setCPFueraArea(true);       
            if(esServicioInternacional)
            {
                setRecoleccion({
                    ...copiaRecoleccion,
                    aceptaCita: false,
                    serviciosAdicionales: [], 
                    tipoRecoleccionId: 1,
                    completado: true,
                    esComercioExterior: true,
                    esServicioInternacional: true
                });
            } 
            else
            {
                swal.fire({
                    titleText: traducirMessage(11), // '¡Atención!',
                    text: traducirMessage(52), // "El código postal seleccionado esta fuera de nuestra área de servicio.\r\nFavor de elegir alguna de las sucursales Almex disponibles en el catálogo.",
                    type: 'warning',
                });
                setRecoleccion({ ...copiaRecoleccion, esServicioInternacional: false, esComercioExterior:false });
            }
            
        }
    };
    
    
    const setDatosRecoleccion = (areaServicio: AreaServicio, copiaRecoleccion: IRecoleccion, sucursal?: Sucursal) => {
        let esServicioInternacional = copiaRecoleccion.paisId === enums.pais.usa;

        if (areaServicio.id > 0) {
            const esRadConCita = props.cliente.esRadConCita && areaServicio.esRadConCita;
            const esEadConCita = props.cliente.esEadConCita && areaServicio.esEadConCita;
            let serviciosAdicionales = obtenerServiciosAdicionales(areaServicio.serviciosAdicionales, true, props.esOrigen);
            let serviciosOrigenDestino = serviciosAdicionales.filter(s => s.esSeccionOrigenDestino);
            let tieneCruceFronterizo = serviciosOrigenDestino.some(e => e.nombre.includes("FLETE CRUCE FRONTERIZO"));
            const serviciosSeccionSevcios = serviciosAdicionales.filter(s => s.esSeccionServiciosAdicionales);
            const copiaAreaServicio = new AreaServicio({ ...areaServicio, serviciosAdicionales: serviciosSeccionSevcios });
            copiaAreaServicio.ObtenerGrupoHorarios();
            let esPuertoAeropuerto = false;
            let esComercioExterior = esPuertoAeropuerto || esServicioInternacional;
 
            if (props.esOrigen) {
                serviciosOrigenDestino = esRadConCita ? serviciosOrigenDestino : serviciosOrigenDestino.filter(c => c.nombre !== 'CARGO POR CITA RAD');
            }
            else {
                serviciosOrigenDestino = esEadConCita ? serviciosOrigenDestino : serviciosOrigenDestino.filter(c => c.nombre !== 'CARGO POR CITA EAD')
            }

            setRecoleccion({
                ...copiaRecoleccion,
                tieneCruceFronterizo,
                areaServicio: copiaAreaServicio,
                sucursal: sucursal || new Sucursal(areaServicio.sucursal),
                aceptaCita: ((props.esOrigen && esRadConCita) || (!props.esOrigen && esEadConCita) || localStorage["tipo_usuario"].toLowerCase() === "invitado"),
                esForanea: areaServicio.esForanea,
                serviciosAdicionales: serviciosOrigenDestino,
                esComercioExterior: esComercioExterior,
                esServicioInternacional: esServicioInternacional
            });
        } else {
            setCPFueraArea(true);       
            if(esServicioInternacional)
            {                
                setRecoleccion({
                    ...copiaRecoleccion,
                    aceptaCita: false,
                    serviciosAdicionales: [], 
                    tipoRecoleccionId: 1, 
                    completado: true,
                    esComercioExterior: true,
                    esServicioInternacional: true,
                    eliminaRetornoDocumentos:  true
                });
            } 
            else
            {
                swal.fire({
                    titleText: traducirMessage(11), // '¡Atención!',
                    text: traducirMessage(52), // "El código postal seleccionado esta fuera de nuestra área de servicio.\r\nFavor de elegir alguna de las sucursales Almex disponibles en el catálogo.",
                    type: 'warning',
                });
                setRecoleccion({ ...copiaRecoleccion, esComercioExterior: false, esServicioInternacional: false });
            }

        }
    };

    const handlePais = (event) => {
        setRecoleccion({ ...initialRecoleccionState, paisId: Number(event.target.value) });
        setCodigoPostal(null);
    };

    const handleCodigoPostalRender = async (event, optionSelected) => {
        setCPFueraArea(false);
        setCodigoPostal(optionSelected);
        let colonia;

        if (optionSelected !== null) {
            colonia = new Colonia(optionSelected);
            let parameters = obtenerParametrosAreaServicio(colonia,optionSelected.id);

            if (props.cotizacionId == 0) {
                const result: AreaServicio = await apiSource.obtenerAsync("area-servicio/by-colonia", parameters);
                const areaServicio: AreaServicio = new AreaServicio(result);

                //Limpia la recolección y pone los valores del código postal seleccionado
                const nuevaRecoleccion = {
                    ...initialRecoleccionState,
                    paisId: recoleccion.paisId,
                    colonia: colonia,
                    direccion: colonia.direccion,
                    codigoPostal: colonia.codigoPostal,
                    sinAreaServicio: areaServicio.id === 0
                };

                setDatosRecoleccionRender(areaServicio, nuevaRecoleccion);
            } else {
                const result: AreaServicio = await apiSource.obtenerAsync("area-servicio/by-colonia", parameters);
                const areaServicio: AreaServicio = new AreaServicio(result);
                setDatosRecoleccionRender(areaServicio, props.value);
            }
        } else {
            setRecoleccion({ ...recoleccion, codigoPostal: "", completado: false });
        }
    };

    const handleCodigoPostal = async (event, optionSelected) => {
        setCPFueraArea(false);
        setCodigoPostal(optionSelected);
        let colonia;

        if (optionSelected !== null) {
            colonia = new Colonia(optionSelected);
            let parameters = obtenerParametrosAreaServicio(colonia,optionSelected.id);

            if (props.cotizacionId == 0) {
                const result: AreaServicio = await apiSource.obtenerAsync("area-servicio/by-colonia", parameters);
                const areaServicio: AreaServicio = new AreaServicio(result);

                //Limpia la recolección y pone los valores del código postal seleccionado
                const nuevaRecoleccion = {
                    ...initialRecoleccionState,
                    paisId: recoleccion.paisId,
                    colonia: colonia,
                    direccion: colonia.direccion,
                    codigoPostal: colonia.codigoPostal,
                    sinAreaServicio: areaServicio.id === 0
                };

                setDatosRecoleccion(areaServicio, nuevaRecoleccion);
            } else {
                const result: AreaServicio = await apiSource.obtenerAsync("area-servicio/by-colonia", parameters);
                const areaServicio: AreaServicio = new AreaServicio(result);
                setDatosRecoleccion(areaServicio, props.value);
            }
        } else {
            setRecoleccion({ ...recoleccion, codigoPostal: "", completado: false, esComercioExterior: false, esServicioInternacional: false });
        }
    };

    const obtenerParametrosAreaServicio = (colonia, coloniaId)=>
    {
        let parametros = {
            paisId : colonia.pais?.id,
            estadoId: colonia.estado?.id,
            ciudadId: colonia.ciudad?.id,
            codigoPostal: colonia?.codigoPostal,
            empresaId : props.cliente?.empresaID,
            coloniaId : coloniaId
        };

        return parametros;
    }
    const handleTipoRecoleccion = async (tipoRecoleccionId) => {
        if (cpFueraArea && !recoleccion.esServicioInternacional) {
            swal.fire({
                titleText: traducirMessage(11), //'¡Atención!',
                text: traducirMessage(193), // "No contamos con oficina en la población solicitada, favor de seleccionar la oficina ocurre más conveniente a su ubicación, haga clic en buscar opciones para seleccionar la oficina más conveniente",
                type: 'error',
            });
        }

        if (recoleccion.esForanea && tipoRecoleccionId === enums.tipoRecoleccion.ocurre) {
            swal.fire({
                titleText: traducirMessage(11), //'¡Atención!',
                text: traducirMessage(151), // "La población seleccionada solo cuenta con servicio de Recolección a Domicilio, para ofrecer el servicio Ocurre deberá elegir alguna de las sucursales Almex disponibles en el catálogo.",
                type: 'warning',
            });
        }

        const esOcurre = tipoRecoleccionId === enums.tipoRecoleccion.ocurre;
        const cambiarAreaServicio = esOcurre || recoleccion.tipoRecoleccionId === enums.tipoRecoleccion.ocurre;

        if (!cambiarAreaServicio || (cpFueraArea && !recoleccion.esServicioInternacional)) {
            updateRecoleccion(tipoRecoleccionId, "tipoRecoleccionId");
            return;
        }

        let result;

        if (esOcurre) {
            const areaServicioId = recoleccion.sucursal?.ocurreAreaServicioId || 0;
            result = await apiSource.obtenerPorIdAsync("area-servicio", areaServicioId);
        } else {
            const coloniaIds = recoleccion.colonia?.ObtenerIds();
            let parameters= obtenerParametrosAreaServicio(recoleccion.colonia, recoleccion.colonia?.id);
            result = await apiSource.obtenerAsync("area-servicio/by-colonia", parameters);
        }

        const areaServicio = new AreaServicio(result);
        const copiaRecoleccion = { ...recoleccion, tipoRecoleccionId, completado: true };

        setDatosRecoleccion(areaServicio, copiaRecoleccion);
    };

    const handleFecha = (fecha: Date | null) => {

        if (fecha !== null) {
            updateRecoleccion(fecha, "fechaCita");
            if (recoleccion.serviciosAdicionales?.length) {
                /*  recoleccion.serviciosAdicionales?.forEach(s => {
                      if (s.nombre === 'CARGO POR CITA RAD' || s.nombre === 'CARGO POR CITA EAD') {
                          s.seleccionado = true;
                      }
                  });*/
            }
        }

        if (fecha === null) {
            updateRecoleccionNull(null, "fechaCita");
        }

    };

    const handleFechaCedis = (fecha: Date | null) => {

        if (fecha !== null) {
            updateRecoleccion(fecha, "fechaCitaCedis");
            if (recoleccion.serviciosAdicionales?.length) {
                /*  recoleccion.serviciosAdicionales?.forEach(s => {
                      if (s.nombre === 'CARGO POR CITA RAD' || s.nombre === 'CARGO POR CITA EAD') {
                          s.seleccionado = true;
                      }
                  });*/
            }
        }

        if (fecha === null) {
            updateRecoleccionNull(null, "fechaCitaCedis");
        }

    };

    const handleFechaRecoleccion = (fecha: Date | null) => {
        updateRecoleccion(fecha, "fechaRecoleccion");

        if (fecha) {
            updateSolicitudCopiaFH("fechaCita", null, "horaFHDe", null, "horaFHHasta", null);
        }

        if (fecha !== null) {
            setRecoleccion({ ...recoleccion, fechaRecoleccion: fecha });
        }

        /*  if (recoleccion.serviciosAdicionales?.length) {
              recoleccion.serviciosAdicionales?.forEach(s => {
                  if (s.nombre === 'CARGO POR CITA RAD' || s.nombre === 'CARGO POR CITA EAD') {
                      s.seleccionado = true;
                  }
              });
          }*/
    };

    const handleFechaFueraHorario = (fecha: Date | null, horaDe: string | null, horaHasta: string | null) => {
        updateRecoleccionFueraHorario(fecha, "fechaCita", horaDe, "horaFHDe", horaHasta, "horaFHHasta");
    };

    const handleSucursal = async (sucursal?: Sucursal) => {
        setRecoleccion({ ...recoleccion, sucursal, completado: true });

        if (sucursal?.ocurreAreaServicioId) {
            const result: AreaServicio = await apiSource.obtenerPorIdAsync("area-servicio", sucursal.ocurreAreaServicioId);
            const areaServicio: AreaServicio = new AreaServicio(result);
            setDatosRecoleccion(areaServicio, recoleccion, sucursal);
        }
    };

    const handleServicio = (servicio: ServicioAdicional) => {
        const nuevosServicios = recoleccion.serviciosAdicionales?.map(sa => sa.id !== servicio.id ? sa : servicio);

        updateRecoleccion(nuevosServicios, "serviciosAdicionales");
    };

    const siguientePaso = () => {
        const servicioSinCantidad = recoleccion.serviciosAdicionales?.some(e => e.CantidadInvalida());
        const servicioSinCosto = recoleccion.serviciosAdicionales?.some(e => e.CostoInvalido());

        if (servicioSinCantidad || servicioSinCosto) {
            let error = servicioSinCantidad ? traducirMessage(103) : // "Favor de ingresar una cantidad en todos los servicios adicionales seleccionados." :
                traducirMessage(99); //"Favor de capturar un costo en la sección de adicionales";
            enqueueSnackbar(error, { variant: "error" });

            return;
        }

        props.siguientePaso(recoleccion, props.esOrigen);
    }

    const handleSolicitarDeNuevo = (solicita: boolean | null, seleccion: number | null) => {}

    const handleSolicitarDeNuevoOrigen = (solicita: boolean | null, seleccion: number | null) => {}

    return (<>
        <Grid item xs={12}>
            {
                props.esOrigen
                    ? <Help comments={traducirMessage(37)} customStyle={{ top: "-30px", right: "-20px" }} />
                    : <Help comments={traducirMessage(36)} customStyle={{ top: "-30px", right: "-20px" }} />
            }
        </Grid>

        <Box mb={2} className="title">
            <Grid item xs={12} sm={6} lg={4}>
                {props.esOrigen ? traducirMessage(19) : traducirMessage(29)}
            </Grid>
        </Box>

        <Grid container spacing={2}>

            <Grid item xs={12} sm={6} lg={4}>
                {/* <SelectControl name="pais" source="pais/many" label={"País"} onChange={handlePais}
                    value={recoleccion.paisId} /> */}
                <strong>
                    {/* País */
                        traducirLabel(224)}
                </strong>
                <FormControl fullWidth>


                    <Select onChange={handlePais}
                        fullWidth

                        variant="filled"
                        labelId="pais-label"

                        id="pais"
                        label={traducirLabel(224)} /*"País"*/
                        value={recoleccion.paisId}>
                        {localStorage.getItem("idioma") === 'en-US' && paises !== null && paises.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.etiquetaPais.nombre}
                            </MenuItem>
                        ))}
                        {localStorage.getItem("idioma") !== 'en-US' && paises !== null && paises.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
                <strong>
                    {/* Localidad / CP */
                        traducirMessage(164)}
                </strong>
                <AutocompleteControl name="codigoPostal" source="colonia/by-text-and-country" label=""
                    value={codigoPostal} onChange={handleCodigoPostal}

                    filter={{ paisId: recoleccion.paisId }} />
            </Grid>

        </Grid>

        {recoleccion.codigoPostal !== "" &&
            <Grid container spacing={2}>
                <Grid item md={6} lg={4} />

                <Grid item md={6}>
                    <Box className="title-4">
                        {recoleccion.direccion}
                    </Box>
                </Grid>
            </Grid>
        }

        {recoleccion.codigoPostal !== "" &&                     
            <>
                <Box mt={2} mb={1} className="title-2">
                    {/* Seleccione el tipo de Ubicación */
                        traducirMessage(244)}
                </Box>

                <Grid container spacing={2}>
                    <TipoRecoleccionLista value={recoleccion.tipoRecoleccionId} onClick={handleTipoRecoleccion}
                        recoleccion={recoleccion} mostrarResidencial={true} esOrigen={props.esOrigen} ayuda={props.ayuda} idiomaId={props.idiomaId}
                        mostrarSoloTipos={recoleccion.esServicioInternacional ?[1,2]:undefined}/>
                </Grid>

                {recoleccion.tipoRecoleccionId &&
                    (recoleccion.tipoRecoleccionId === enums.tipoRecoleccion.ocurre ?
                        <SucursalComponente value={recoleccion.sucursal} esOrigen={props.esOrigen} onChange={handleSucursal} ayuda={props.ayuda} />
                        : <RecoleccionFecha
                            esOrigen={props.esOrigen}
                            esSolicitud={false}
                            setFecha={handleFecha}
                            setFechaRecoleccion={handleFechaRecoleccion}
                            setFechaFH={handleFechaFueraHorario}
                            aceptaCita={recoleccion.aceptaCita && !recoleccion.esServicioInternacional}
                            value={recoleccion.fechaCita}
                            valueRecoleccion={recoleccion.fechaRecoleccion}
                            valueCedis={recoleccion.fechaCitaCedis}
                            horarios={recoleccion.areaServicio?.grupoHorarios}
                            cliente={props.cliente}
                            ayuda={props.ayuda}
                            horarioArea={recoleccion.areaServicio?.horarios}
                            valueHoraDe={recoleccion.horaFHDe}
                            valueHoraHasta={recoleccion.horaFHHasta}
                            EsFueraHorario={recoleccion.EsFueraHorario}
                            areaServicio={recoleccion.areaServicio}
                            solicitudCopia={props.solicitudCopia}
                            recoleccion={recoleccion}
                            setFechaCedis={handleFechaCedis}
                            setSolicitaDeNuevoDestino ={(handleSolicitarDeNuevo)}
                            setSolicitaDeNuevoOrigen={handleSolicitarDeNuevoOrigen}
                        />
                    )
                }
            </>
            }
            {
                    recoleccion.completado && recoleccion.serviciosAdicionales && recoleccion.serviciosAdicionales.length > 0 &&
                    <>
                        <Box mt={2} mb={1} className="title-2">
                            {/* ¿Requiere Servicios Adicionales? */
                                traducirMessage(30)}
                        </Box>
                        {recoleccion.serviciosAdicionales.length > 0 &&
                            <ServicioAdicionalLista onSelect={handleServicio} ayuda={props.ayuda}
                                paisId={recoleccion.paisId} esOrigen={props.esOrigen}
                                servicios={recoleccion.serviciosAdicionales} />
                        }
                    </>
                }

        {recoleccion.completado && (recoleccion.esServicioInternacional || (!cpFueraArea || !!recoleccion.sucursal))  &&
            <NextButton nextStep={siguientePaso} />
        }
    </>)
}

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    solicitudCopia: state.solicitudCopia,
    ayuda: state.ayuda,
    paises: state.paises
});

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia
};

export default connect(mapStateToProps, mapDispatchToProps)(Recoleccion);
